import { userInfoSync } from 'hub-http/userInfo';
export function hasAllGates(gatesNeeded) {
  const userGates = userInfoSync().gates;
  // If the gates needed are provided, check if the user has all of the gates needed
  return gatesNeeded.length > 0 ? gatesNeeded.every(gateName =>
  // The assumption here is that the gate names passed in will already have the gate() function applied to them
  userGates.includes(gateName)) : true;
}